import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.card-toggle__background-splide' ).length && $( '.card-toggle__card-splide' ).length ) {
        const backgroundSplide = new Splide( '.card-toggle__background-splide', {
          type: 'fade',
          rewind: true,
          perPage: 1,
          perMove: 1,
          pagination: false,
          arrows: false,
          speed: 800,
        } );

        const cardSplide = new Splide( '.card-toggle__card-splide', {
          type: 'fade',
          rewind: true,
          perPage: 1,
          perMove: 1,
          pagination: false,
          arrows: false,
          speed: 800,
        } );

        backgroundSplide.sync( cardSplide );
        backgroundSplide.mount();
        cardSplide.mount();

        $( '.card-toggle__splide-tab:first-of-type' ).addClass( 'is-active' );

        // const cardCount = $( '.card-toggle__splide-tab' ).length;
        // let nextTab = 0;
        let goToSlide;

        // function startInterval() {// eslint-disable-line
        //   goToSlide = setInterval( function progressBar() {
        //     const activeTab = $( '.card-toggle__splide-tab.is-active' ).data( 'splide' );
        //     nextTab = ( activeTab + 1 ) % cardCount;
        //     cardSplide.go( nextTab );
        //   }, 6000 );
        // }

        // startInterval();

        // $( '.card-toggle__splide-tab' ).on( 'click', function() {
        //   if ( $( this ).hasClass( 'is-active' ) ) return;
        //   clearInterval( goToSlide );
        //   const goToSplide = $( this ).data( 'splide' );
        //   $( '.card-toggle__splide-tab' ).removeClass( 'is-active' );
        //   cardSplide.go( goToSplide );
        //   $( this ).addClass( 'is-active' );
        //   startInterval();
        // } );

        // $( '.card-toggle__splide-tab' ).on( 'mouseenter', function() {
        //   clearInterval( goToSlide );
        //   $( '.card-toggle__splide-tab' ).removeClass( 'is-active' );
        // } );

        $( '.card-toggle__splide-tab' ).on( 'click', function() {
          const goToSplide = $( this ).data( 'splide' );
          cardSplide.go( goToSplide );
          $( this ).addClass( 'is-active' );
          startInterval();
        } );

        cardSplide.on( 'move', function( newIndex, prevIndex, destIndex ) {
          $( '.card-toggle__splide-tab' ).removeClass( 'is-active' );
          $( `.card-toggle__splide-tab[data-splide="${destIndex}"]` ).addClass( 'is-active' );
        } );

        $( '.splide__prev' ).on( 'click', function() {
          cardSplide.go( '<' );
        } );

        $( '.splide__next' ).on( 'click', function() {
          cardSplide.go( '>' );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'card-toggle', COMPONENT );
} )( app );
